import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Autocomplete from '@mui/material/Autocomplete';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';


const CreateSmtp = (props) => {
  const {
    is_email_config_modal_open,
    handleConfigModal,
    handleConfigSubmit,
    handleConfigUpdate,
    c_action,
    config_id,
    selected_data,
    company_list,
    process_list
  } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const handleConfigCloseModalChange = () => {
    formik.resetForm();
    handleConfigModal(false);
  };

  const validationSchema = yup.object().shape({
    mail_username: yup.string().trim().required('Mail Username is required.'),
    mail_password: yup.string().trim().required('Mail Password is required.'),
    mail_port: yup.number().required('Mail Port is required.'),
    mail_server: yup.string().trim().required('Mail Server is required.'),
    mail_form_name: yup.string().trim().required('Mail Form Name is required.'),
    mail_cc: yup.string().email('Enter a valid email').required('Mail CC is required.'),
    company_id: yup.number().required('Company ID is required.'),
    process_id: yup.number().required('Process ID is required.'),
  });

  const onSubmit = async (values) => {
    let res_create, res_update;
    if (c_action === "UPDATE") {
      const payload = { config_id, updated_data: values };
      res_update = await handleConfigUpdate(payload);
    } else {
      res_create = await handleConfigSubmit(values);
    }

    if ((res_create || res_update) && !(res_create?.error || res_update?.error)) {
      formik.resetForm();
      handleConfigModal(false);
      window.location.reload();
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      mail_username: c_action === "UPDATE" ? selected_data.mail_username : '',
      mail_password: c_action === "UPDATE" ? selected_data.mail_password : '',
      mail_port: c_action === "UPDATE" ? selected_data.mail_port : '',
      mail_server: c_action === "UPDATE" ? selected_data.mail_server : '',
      mail_form_name: c_action === "UPDATE" ? selected_data.mail_form_name : '',
      mail_cc: c_action === "UPDATE" ? selected_data.mail_cc : '',
      company_id: c_action === "UPDATE" ? selected_data.company_id : '',
      process_id: c_action === "UPDATE" ? selected_data.process_id : '',
    },
    validationSchema: validationSchema,
    onSubmit,
  });


  return (
    <Dialog
      fullScreen={fullScreen}
      open={is_email_config_modal_open}
      onClose={handleConfigCloseModalChange}
      aria-labelledby="responsive-dialog-title"
      component="form"
      onSubmit={formik.handleSubmit}
    // sx={{ '& .MuiDialog-paper': { width: '310px' } }}
    >
      <DialogTitle
        id="responsive-dialog-title"
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        {(c_action === 'UPDATE' && 'Update Email Configuration') || (c_action === 'CREATE' && 'Create Email Configuration')}
        <IconButton size="medium" onClick={handleConfigCloseModalChange}>
          <CloseOutlinedIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          '& .MuiTextField-root,.MuiFormControl-root': {
            my: 1.2,
            width: { md: '30ch', xs: '100%' },
            fontSize: '14px'
          },
          '& .MuiStack-root > .MuiFormControl-root:first-of-type': {
            marginRight: { md: 1, xs: 0 }
          },
          '& .MuiStack-root > .MuiFormControl-root:last-child': {
            marginLeft: { md: 1, xs: 0 }
          },
        }}
      >

        <Stack sx={{
          display: 'flex',
          flexDirection: { md: 'row', xs: 'column' },
          justifyContent: 'space-between'
        }}>
          <TextField
            label="Mail Username"
            variant="outlined"
            size="small"
            name="mail_username"
            value={formik.values.mail_username}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.mail_username && Boolean(formik.errors.mail_username)}
            helperText={formik.touched.mail_username && formik.errors.mail_username}
          />

          <TextField
            label="Mail Password"
            variant="outlined"
            size="small"
            type="password"
            name="mail_password"
            value={formik.values.mail_password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.mail_password && Boolean(formik.errors.mail_password)}
            helperText={formik.touched.mail_password && formik.errors.mail_password}
          />
        </Stack>
        <Stack sx={{
          display: 'flex',
          flexDirection: { md: 'row', xs: 'column' },
          justifyContent: 'space-between'
        }}>
          <TextField
            label="Mail Port"
            variant="outlined"
            size="small"
            type="number"
            name="mail_port"
            value={formik.values.mail_port}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.mail_port && Boolean(formik.errors.mail_port)}
            helperText={formik.touched.mail_port && formik.errors.mail_port}
          />

          <TextField
            label="Mail Server"
            variant="outlined"
            size="small"
            name="mail_server"
            value={formik.values.mail_server}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.mail_server && Boolean(formik.errors.mail_server)}
            helperText={formik.touched.mail_server && formik.errors.mail_server}
          />
        </Stack>
        <Stack sx={{
          display: 'flex',
          flexDirection: { md: 'row', xs: 'column' },
          justifyContent: 'space-between'
        }}>
          <TextField
            label="Mail Form Name"
            variant="outlined"
            size="small"
            name="mail_form_name"
            value={formik.values.mail_form_name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.mail_form_name && Boolean(formik.errors.mail_form_name)}
            helperText={formik.touched.mail_form_name && formik.errors.mail_form_name}
          />

          <TextField
            label="Mail CC"
            variant="outlined"
            size="small"
            name="mail_cc"
            value={formik.values.mail_cc}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.mail_cc && Boolean(formik.errors.mail_cc)}
            helperText={formik.touched.mail_cc && formik.errors.mail_cc}
          />
        </Stack>
        <Stack sx={{
          display: 'flex',
          flexDirection: { md: 'row', xs: 'column' },
          justifyContent: 'space-between'
        }}>
          <Autocomplete
            fullWidth
            options={company_list || []}
            getOptionLabel={(option) => option.name || ""}
            value={company_list?.find(c => c.id === formik.values.company_id) || null}
            onChange={(event, newValue) => {
              formik.setFieldValue("company_id", newValue ? newValue.id : null);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Company"
                variant="outlined"
                size="small"
                error={formik.touched.company_id && Boolean(formik.errors.company_id)}
                helperText={formik.touched.company_id && formik.errors.company_id}
              />
            )}
            sx={{ width: { xs: '100%' }, my: 1.2, marginRight: { md: 1, xs: 0 } }}
          />

          <Autocomplete
            fullWidth
            options={process_list || []}
            getOptionLabel={(option) => option.name || ""}
            value={process_list?.find(p => p.id === formik.values.process_id) || null}
            onChange={(event, newValue) => {
              formik.setFieldValue("process_id", newValue ? newValue.id : null);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Process"
                variant="outlined"
                size="small"
                error={formik.touched.process_id && Boolean(formik.errors.process_id)}
                helperText={formik.touched.process_id && formik.errors.process_id}
              />
            )}
            sx={{ width: { xs: '100%' }, my: 1.2, marginLeft: { md: 1, xs: 0 } }}
          />
        </Stack>

      </DialogContent>

      <DialogActions
        sx={{
          padding: '8px 16px 24px 24px',
          '& .MuiButtonBase-root:last-child': {
            marginLeft: '16px'
          }
        }}
      >
        <Button
          variant="outlined"
          color="error"
          onClick={handleConfigCloseModalChange}
          sx={{ fontSize: { xs: '12px', sm: '14px' }, borderColor: "#ff6100", color: "#4c4e52" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          type="submit"
          sx={{ fontSize: { xs: '12px', sm: '14px' }, backgroundColor: "#ff6100" }}
        >
          {(c_action === 'UPDATE' && 'Update') || (c_action === 'CREATE' && 'Submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateSmtp;
